export default __webpack_public_path__ + "static/media/me-icon-active.7f71d213.webp";